module.exports = __webpack_public_path__ + "img/ManageClientTeam.f30aada1.svg";